import { Button } from "@/ui";
import { CartProduct, type CartProductProps } from "./cart-product";

type CartRecommendedProductProps = CartProductProps & {
  disabled?: boolean;
  onQuantityChange: (quantity: number) => void;
};

export const CartRecommendedProduct = ({
  disabled = false,
  onQuantityChange,
  product,
}: CartRecommendedProductProps) => {
  if (product.source !== "recommended") {
    return null;
  }

  return (
    <CartProduct.Root className="flex flex-col gap-4 p-5 shadow-none" product={product}>
      <div className="flex gap-4">
        <CartProduct.Image className="size-20 rounded-lg sm:size-20" />
        <div className="flex flex-1 flex-col gap-1">
          <div className="flex justify-between gap-2">
            <CartProduct.Name level={3} />
          </div>
          <CartProduct.Price />
        </div>
      </div>

      {product.quantity >= 1 ? (
        <>
          <div className="flex items-center justify-between">
            <CartProduct.Quantity disabled={disabled} onChange={onQuantityChange} />
          </div>

          <div className="flex items-end justify-between">
            <CartProduct.ShippingFrequency />
            <p className="text-sm text-content-muted italic">Cancel anytime. No commitments.</p>
          </div>
        </>
      ) : (
        <Button
          className="w-full rounded-lg"
          disabled={disabled}
          onClick={() => {
            return onQuantityChange(1);
          }}
          variant="secondary-dark"
        >
          Add to Cart
        </Button>
      )}
    </CartProduct.Root>
  );
};
